module.exports = __webpack_public_path__ + "img/44ne.34dc2815.svg";